import { NotificationsBell } from "@/components/NotificationsBell";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="sticky top-0 z-30 backdrop-blur-xl bg-background/75 border-b border-border/50">
      <div className="px-4 md:px-10 py-4 md:py-6 flex flex-wrap items-center justify-between gap-3 md:gap-6">
        <div className="min-w-0">
          <h1 className="text-xl md:text-3xl font-semibold tracking-tight truncate">{title}</h1>
          {subtitle && <p className="mt-1 text-xs md:text-sm text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="flex flex-wrap items-center gap-2 md:gap-3">
          {actions}
          <NotificationsBell />
        </div>
      </div>
    </div>
  );
}
